import { render, staticRenderFns } from "./series-normal-label.vue?vue&type=template&id=ab29826a"
import script from "./series-normal-label.vue?vue&type=script&lang=js"
export * from "./series-normal-label.vue?vue&type=script&lang=js"
import style0 from "./series-normal-label.vue?vue&type=style&index=0&id=ab29826a&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports